import React, { useState, useRef } from "react";
import { PaperClipIcon, XMarkIcon } from "@heroicons/react/24/outline";
import useDashboard from "../../../customHooks/useDashboard";
import { Link, useNavigate } from "react-router-dom";
import { atom, useAtom } from "jotai";
import { USER_DETAILS } from "../../layout/Layout";
import axios from "axios";
import { BASE_URL } from "../../../customHooks/config";
import { toast } from "react-toastify";
import Spinner from "../../layout/loader/Spinner";
export const USER_DETAILS_UPDATE_WELCOME_MSG = atom({});


function WelcomeMsg({ setStep, handleClose }) {
  const [prefill, setPrefill] = useState(false);
  const [userInfoUpdateMsg, setUserInfoUpdateMsg] = useAtom(USER_DETAILS_UPDATE_WELCOME_MSG);
  const [userDetails] = useAtom(USER_DETAILS);
  const vendorId = userDetails?.data?.user_details?.vendor_details?.vendor_id;

  const inputRef = useRef(null);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleFile = (e) => {
    const res = e.target.files[0];
    setFile(res);
  };
  const handleRemoveFile = () => {
    setFile(null);
    setPrefill(false);
  };

  const handleUpload = () => {

    if (file) {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("vendor", vendorId)
      axios.post(`${BASE_URL}vendor/upload_agreement/`, formData, { withCredentials: true })
        .then(res => {
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            setStep(2);
            setUserInfoUpdateMsg({ ...userInfoUpdateMsg, changed: true })
          } else {
            toast.error(res?.data?.data?.message);
          }
          setLoading(false);
        }).catch(err => {
          toast.error(err?.data?.error);
          setLoading(false);
        })
    }
  }
  return (
    <div>
      <div className="text-center flex flex-col items-stretch px-16  justify-center pt-3">
        <h2 className=" text-3xl flex justify-center items-center text-center mb-1">
          Welcome to <div className="text-[#2563EB]  ml-2 ">GWPartner</div>
        </h2>

        <p className="text-sm text-[#6C757D]">
          You are just 1 step away. Kindly upload the Agreement following the
          steps below:
        </p>

        <div>
          <p className="text-sm text-[#6C757D] text-left leading-6 ">
          Step 1: <a href="https://getwork-store-new.s3.ap-south-1.amazonaws.com/prod/Partner+agreement_Amended_17062024.docx" className="text-[#2563EB] hover:underline">
              {" "}
              Download the Agreement{" "}
            </a>by clicking here.<br /> Step 2: Fill
            in the yellow-marked fields, attach a stamp of INR 300, and sign the
            agreement digitally. <br /> Step 3: Upload the Agreement.
          </p>
        </div>
        <div className="h-fit mt-2 ">
          <div className="bg-[#f8fafc] border border-1 mt-3  border-[#CBD5E1]  rounded-lg flex justify-between  items-center ">
            <div>
              <input
                ref={inputRef}
                type="file"
                onChange={handleFile}
                className="hidden"
                accept=".doc,.docx,.pdf"
              />
              <p className="text-xs text-[#6C757D]">
                {file ? (
                  <p className="text-xs font-bold  text-black flex ml-2 ">
                    <PaperClipIcon className="h-4 w-4 text-[#6C757D] mr-2 " />
                    {file?.name}
                  </p>
                ) : (
                  <>
                    <div className="flex items-center ml-2 ">
                      <PaperClipIcon className="h-4 w-4 text-[#6C757D] mr-2 " />{" "}
                      {prefill ? "Last Uploaded File" : "No attached file"}
                    </div>
                  </>
                )}
              </p>
            </div>
            <div>
              {!file && !prefill ? (
                <button
                  onClick={() => {
                    inputRef.current.click();
                  }}
                  className="bg-[#6C757D] text-white h-[40px] text-sm  rounded-md px-3 font-normal flex items-center "
                >
                  Choose file
                </button>
              ) : (
                <button
                  onClick={handleRemoveFile}
                  className="bg-[#2563EB] rounded-md h-[40px] w-[40px] flex justify-center items-center "
                >
                  <XMarkIcon className="h-4 w-4 text-white " />
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="flex flex-col mt-6 pb-8">
          <button
            onClick={handleUpload}
            className="bg-[#2563EB] text-white text-center h-[40px] text-sm  rounded-md px-3 font-normal flex justify-center items-center "
          >
            {loading ? <Spinner /> : "Upload"}
          </button>
          <button className="w-[100%] border border-[#6C757D] text-[#6C757D] text-center h-[40px] text-sm  rounded-md px-3 font-normal flex justify-center items-center mt-3 " onClick={handleClose}>
            View job
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeMsg;
